import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { ButtonSeeker } from 'ui-seeker/core'
import { formatRangesCsv, formatRangesLabel } from 'app/@utils/dayMonthRanges'
import './ClosedPeriodsHint.css'

// Yellow warning for a business date form: the main hotel has seasonal closed periods, so the recommended business
// date (active season) is the rest of the year. "Apply" fills the field with it. Hidden when already applied.
// messageKey: text variant (compset by default; 'common:dayMonthRanges.closedHint.messageReport' for reports).
export default function ClosedPeriodsHint({ closedPeriods, recommended, value, onApply, messageKey = 'common:dayMonthRanges.closedHint.message' }) {
    const { t } = useTranslation('common')
    if (!closedPeriods?.length || !recommended || value === recommended) return null

    return <div className="closed-periods-hint">
        <span className="closed-periods-hint-text">
            {t(messageKey, {
                closed: formatRangesLabel(formatRangesCsv(closedPeriods)),
                recommended: formatRangesLabel(recommended),
            })}
        </span>
        <ButtonSeeker variant="outlined" size="small" className="closed-periods-hint-apply" onClick={() => onApply(recommended)}>
            {t('common:dayMonthRanges.closedHint.apply')}
        </ButtonSeeker>
    </div>
}
